import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Grid,
    Card,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Box,
    CircularProgress,
    Snackbar,
    Alert,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormHelperText,
    Tooltip
} from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { CloudUpload, Delete, Add, Close, Warning } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import MDButton from 'components/MDButton';
import { PUT, POST } from 'APIclient';
import properties from 'constants/ApplicationConstants';
import { GET } from 'APIclient';

const AdditionalItemsSection = ({
    items,
    handleAdditionalItemChange,
    handleRemoveAdditionalItem,
    handleAddAdditionalItem,
    validationErrors,
    disabled,
}) => {
    return (
        <>
            {items.map((item, index) => (
                <Grid
                    container
                    spacing={2}
                    key={index}
                    sx={{ mt: 0, alignItems: 'center', borderBottom: '1px solid #e0e0e0', pb: 1 }}
                >
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            variant="standard"
                            placeholder="Enter particular"
                            value={item.particular || item.itemName || ''}
                            onChange={(e) => handleAdditionalItemChange(index, 'particular', e.target.value)}
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl
                            fullWidth
                            variant="standard"
                            error={validationErrors[`additionalItem_${index}_status`]}
                        >
                            <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                            <Select
                                value={item.status || ''}
                                onChange={(e) => handleAdditionalItemChange(index, 'status', e.target.value)}
                                disabled={disabled}
                            >
                                {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                <MenuItem value="N/A">N/A</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="Submitted">Submitted</MenuItem>
                            </Select>
                            {validationErrors[`additionalItem_${index}_status`] && (
                                <FormHelperText>Please select a status</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            variant="standard"
                            placeholder="Employee comment"
                            value={item.employeeComment || ''}
                            disabled
                            sx={{
                                '& .MuiInputBase-input.Mui-disabled': {
                                    WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                    backgroundColor: '#f5f5f5',
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            variant="standard"
                            placeholder="Enter department comment"
                            value={item.departmentComment || ''}
                            onChange={(e) => handleAdditionalItemChange(index, 'departmentComment', e.target.value)}
                            disabled={disabled}
                            error={validationErrors[`additionalItem_${index}_departmentComment`]}
                            helperText={validationErrors[`additionalItem_${index}_departmentComment`] ? 'Department comment is required' : ''}
                        />
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <IconButton
                            size="small"
                            onClick={() => handleRemoveAdditionalItem(index)}
                            color="error"
                            disabled={disabled}
                        >
                            <Delete fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
            <Button
                variant="outlined"
                size="small"
                startIcon={<Add />}
                onClick={handleAddAdditionalItem}
                disabled={disabled}
                sx={{
                    mt: 1,
                    color: 'rgba(158, 97, 97, 0.93)',
                    borderColor: 'black',
                    '&:hover': {
                        borderColor: 'black',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                }}
            >
                Add New Row
            </Button>
        </>
    );
};

const ITClearanceUpdateForm = ({ open, onClose, clearanceData, onSuccess, readOnly = false }) => {
    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [approveLoading, setApproveLoading] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackColor, setSnackColor] = useState('success');
    const [snackMessage, setSnackMessage] = useState('');
    const [isAlreadyApproved, setIsAlreadyApproved] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [openSignatureDialog, setOpenSignatureDialog] = useState(false);
    const [existingSignature, setExistingSignature] = useState(null);
    const [signatureChoice, setSignatureChoice] = useState('existing');
    const [newSignature, setNewSignature] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    const empId = localStorage.getItem("empId") || "";
    console.log('the value of clearance data', clearanceData);
    const [openSimpleSignatureDialog, setOpenSimpleSignatureDialog] = useState(false);
    const [employeeAssets, setEmployeeAssets] = useState([]);
    const [assetsLoading, setAssetsLoading] = useState(false);

    const existingEmpId = clearanceData?.empId;

    const [formData, setFormData] = useState({
        empId: empId || '',
        emailDeletion: '',
        empEmailIdComment: '',
        departmentEmailIdComment: '',
        // Email Retention - NEW
        emailRetention: '',
        empEmailRetentionComment: '',
        departmentEmailRetentionComment: '',
        laptopReturned: '',
        empLaptopReturnedComment: '',
        departmentLaptopReturnedComment: '',
        backupCdReturned: '',
        empBackupCdComment: '',
        departmentBackupCdComment: '',
        systemLoginDeactivated: '',
        empSystemLoginComment: '',
        departmentSystemLoginComment: '',
        biometricDeleted: '',
        empBiometricComment: '',
        departmentBiometricComment: '',
        additionalItem: [],
        clearanceDate: dayjs(),
    });

    // Map backend status to frontend display values
    const mapBackendStatusToFrontend = (status) => {
        switch (status?.toUpperCase()) {
            case 'YES':
                return 'Submitted';
            case 'NO':
                return 'Pending';
            case 'NA':
                return 'N/A';
            default:
                return '';
        }
    };

    const fetchEmployeeAssets = async (employeeId) => {
        if (!employeeId) return;
        setAssetsLoading(true);
        try {
            const response = await GET(`it-dept/workstation/view/${employeeId}`);
            if (response.data?.statusCode === 200) {
                const allAssets = response.data.data || [];
                const sortedAssets = allAssets.sort((a, b) => {
                    const aReturned = !!a.returnedDate;
                    const bReturned = !!b.returnedDate;
                    return aReturned - bReturned;
                });
                setEmployeeAssets(sortedAssets);
            }
        } catch (error) {
            console.error('Error fetching employee assets:', error);
        } finally {
            setAssetsLoading(false);
        }
    };

    useEffect(() => {
        if (clearanceData) {
            const wasApproved = clearanceData.status?.toLowerCase() === 'approved' ||
                clearanceData.status?.toLowerCase() === 'cleared';
            setIsAlreadyApproved(wasApproved);

            setFormData({
                empId: empId || '',
                emailDeletion: mapBackendStatusToFrontend(clearanceData?.emailIdStatus),
                empEmailIdComment: clearanceData?.empEmailIdComment || '',
                departmentEmailIdComment: clearanceData?.departmentEmailIdComment || '',
                // Email Retention - NEW
                emailRetention: mapBackendStatusToFrontend(clearanceData?.emailRetentionStatus),
                empEmailRetentionComment: clearanceData?.empEmailRetentionComment || '',
                departmentEmailRetentionComment: clearanceData?.departmentEmailRetentionComment || '',
                laptopReturned: mapBackendStatusToFrontend(clearanceData?.laptopReturnedStatus),
                empLaptopReturnedComment: clearanceData?.empLaptopReturnedComment || '',
                departmentLaptopReturnedComment: clearanceData?.departmentLaptopReturnedComment || '',
                backupCdReturned: mapBackendStatusToFrontend(clearanceData?.backupCdStatus),
                empBackupCdComment: clearanceData?.empBackupCdComment || '',
                departmentBackupCdComment: clearanceData?.departmentBackupCdComment || '',
                systemLoginDeactivated: mapBackendStatusToFrontend(clearanceData?.systemLoginDeactivatedStatus),
                empSystemLoginComment: clearanceData?.empSystemLoginComment || '',
                departmentSystemLoginComment: clearanceData?.departmentSystemLoginComment || '',
                biometricDeleted: mapBackendStatusToFrontend(clearanceData?.biometricDeletedStatus),
                empBiometricComment: clearanceData?.empBiometricComment || '',
                departmentBiometricComment: clearanceData?.departmentBiometricComment || '',
                additionalItem: (clearanceData?.additionalItem || []).map(item => ({
                    ...item,
                    status: mapBackendStatusToFrontend(item.status)
                })),
                clearanceDate: clearanceData?.clearanceDate ? dayjs(clearanceData.clearanceDate) : dayjs(),
            });

            setExistingSignature(wasApproved ? clearanceData?.managerSignature : null);
            setHasChanges(false);
            setSignatureChoice('existing');
            setNewSignature(null);
            setValidationErrors({});
        }
        console.log("The value of clearanceData is: ", clearanceData?.employeeId);

        if (clearanceData?.employeeId) {
            fetchEmployeeAssets(clearanceData?.employeeId);
        }
    }, [clearanceData, empId]);

    const handleNestedChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
        setHasChanges(true);
        // Clear validation error for this field
        if (validationErrors[field]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[field];
                return newErrors;
            });
        }
    };


    const handleDateChange = (date) => {
        const validDate = date ? dayjs(date) : null;
        const formatted = validDate?.isValid() ? validDate.format('YYYY-MM-DD') : null;
        setFormData((prev) => ({ ...prev, clearanceDate: formatted }));
        setHasChanges(true);
    };

    const handleNewSignatureUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 2 * 1024 * 1024) {
                setSnackMessage('File size should not exceed 2MB');
                setSnackColor('error');
                setSnackOpen(true);
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                setNewSignature(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveNewSignature = () => {
        setNewSignature(null);
    };

    const handleAddAdditionalItem = () => {
        setFormData((prev) => ({
            ...prev,
            additionalItem: [...prev.additionalItem, {
                particular: '',
                status: '',
                employeeComment: '',
                departmentComment: ''
            }],
        }));
        setHasChanges(true);
    };

    const handleAdditionalItemChange = (index, field, value) => {
        setFormData((prev) => ({
            ...prev,
            additionalItem: prev.additionalItem.map((it, i) =>
                i === index ? { ...it, [field]: value } : it
            ),
        }));
        setHasChanges(true);
        // Clear validation error for this field
        const errorKey = `additionalItem_${index}_${field}`;
        if (validationErrors[errorKey]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[errorKey];
                return newErrors;
            });
        }
    };

    const handleRemoveAdditionalItem = (index) => {
        setFormData((prev) => ({
            ...prev,
            additionalItem: prev.additionalItem.filter((_, i) => i !== index),
        }));
        setHasChanges(true);
        // Clear validation errors for removed item
        setValidationErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[`additionalItem_${index}_status`];
            delete newErrors[`additionalItem_${index}_departmentComment`];
            return newErrors;
        });
    };

    // Map frontend status to backend format
    const mapStatusForBackend = (status) => {
        switch (status) {
            case 'Submitted':
                return 'YES';
            case 'Pending':
                return 'NO';
            case 'N/A':
                return 'NA';
            default:
                return 'NA';
        }
    };

    // Validation function
    const validateForm = () => {
        const errors = {};

        // Validate main fields
        const mainFields = [
            { key: 'emailDeletion', commentKey: 'departmentEmailIdComment' },
            { key: 'emailRetention', commentKey: 'departmentEmailRetentionComment' },
            { key: 'laptopReturned', commentKey: 'departmentLaptopReturnedComment' },
            { key: 'backupCdReturned', commentKey: 'departmentBackupCdComment' },
            { key: 'systemLoginDeactivated', commentKey: 'departmentSystemLoginComment' },
            { key: 'biometricDeleted', commentKey: 'departmentBiometricComment' },
        ];

        mainFields.forEach(({ key, commentKey }) => {
            if (!formData[key] || formData[key] === '') {
                errors[key] = true;
            }
            if (!formData[commentKey] || formData[commentKey].trim() === '') {
                errors[commentKey] = true;
            }
        });

        // Validate additional items
        formData.additionalItem.forEach((item, index) => {
            if (!item.status || item.status === '') {
                errors[`additionalItem_${index}_status`] = true;
            }
            if (!item.departmentComment || item.departmentComment.trim() === '') {
                errors[`additionalItem_${index}_departmentComment`] = true;
            }
        });

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Add this new function after the existing validateForm function
    const checkForPendingItems = () => {
        const pendingItems = [];

        const mainFields = [
            { key: 'emailDeletion', name: 'Deletion of email id' },
            { key: 'emailRetention', name: 'Retention of email id' },
            { key: 'laptopReturned', name: 'Laptop Returned' },
            { key: 'backupCdReturned', name: 'Back up CD returned' },
            { key: 'systemLoginDeactivated', name: 'System login id deactivated' },
            { key: 'biometricDeleted', name: 'Bio Metric entry (delete)' },
        ];

        mainFields.forEach(({ key, name }) => {
            if (formData[key] === 'Pending') {
                pendingItems.push(name);
            }
        });

        formData.additionalItem.forEach((item, index) => {
            if (item.status === 'Pending') {
                const itemName = item.particular || item.itemName || `Additional Item ${index + 1}`;
                pendingItems.push(itemName);
            }
        });

        return pendingItems;
    };

    const checkForUnreturnedAssets = () => {
        return employeeAssets.filter(asset => !asset.returnedDate);
    };

    const handleSubmit = async (e, isApprove = false) => {
        e.preventDefault();

        if (!isApprove) {
            // Just Update (no approval)
            // if (!validateForm()) {
            //     setSnackMessage('Please fill all required fields');
            //     setSnackColor('error');
            //     setSnackOpen(true);
            //     return;
            // }
            await performUpdate(null, false); // No signature, no approval
            return;
        }

        // Check for unreturned assets first
        const unreturnedAssets = checkForUnreturnedAssets();
        if (unreturnedAssets.length > 0) {
            const assetList = unreturnedAssets.map((asset, idx) =>
                `${idx + 1}. ${asset.assetName} (${asset.assetNo}) - ${asset.componentName}`
            ).join('\n');
            setSnackMessage(
                `Cannot approve clearance. The following assets have not been returned:\n\n${assetList}\n\nPlease ensure all assets are returned before approving.`
            );
            setSnackColor('error');
            setSnackOpen(true);
            return;
        }


        const pendingItems = checkForPendingItems();
        if (pendingItems.length > 0) {
            const pendingList = pendingItems.map((item, idx) => `${idx + 1}. ${item}`).join('\n');
            setSnackMessage(
                `Cannot approve clearance. The following items are still pending:\n\n${pendingList}\n\nPlease update all pending items before approving.`
            );
            setSnackColor('error');
            setSnackOpen(true);
            return;
        }

        // === Update & Approve Flow ===
        if (!validateForm()) {
            setSnackMessage('Please fill all required fields');
            setSnackColor('error');
            setSnackOpen(true);
            return;
        }

        // Decide which dialog to open
        if (isAlreadyApproved) {
            // Show Re-approval dialog (existing one with warning)
            setOpenSignatureDialog(true);
        } else {
            // First time approval → simpler dialog or direct upload
            setOpenSimpleSignatureDialog(true); // New state for simple dialog
        }
    };
    const performUpdate = async (signatureForApproval = null, shouldApprove = false) => {
        // Set correct loading state
        if (shouldApprove) {
            setApproveLoading(true);
        } else {
            setUpdateLoading(true);
        }

        try {
            const jwtToken = window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token');

            const updateData = {
                empId: empId || '',
                emailIdStatus: mapStatusForBackend(formData.emailDeletion),
                empEmailIdComment: formData.empEmailIdComment,
                departmentEmailIdComment: formData.departmentEmailIdComment,
                // Email Retention - NEW
                emailRetentionStatus: mapStatusForBackend(formData.emailRetention),
                empEmailRetentionComment: formData.empEmailRetentionComment,
                departmentEmailRetentionComment: formData.departmentEmailRetentionComment,
                laptopReturnedStatus: mapStatusForBackend(formData.laptopReturned),
                empLaptopReturnedComment: formData.empLaptopReturnedComment,
                departmentLaptopReturnedComment: formData.departmentLaptopReturnedComment,
                backupCdStatus: mapStatusForBackend(formData.backupCdReturned),
                empBackupCdComment: formData.empBackupCdComment,
                departmentBackupCdComment: formData.departmentBackupCdComment,
                systemLoginDeactivatedStatus: mapStatusForBackend(formData.systemLoginDeactivated),
                empSystemLoginComment: formData.empSystemLoginComment,
                departmentSystemLoginComment: formData.departmentSystemLoginComment,
                biometricDeletedStatus: mapStatusForBackend(formData.biometricDeleted),
                empBiometricComment: formData.empBiometricComment,
                departmentBiometricComment: formData.departmentBiometricComment,
                additionalItem: formData.additionalItem.map(item => ({
                    ...item,
                    status: mapStatusForBackend(item.status)
                })),
                clearanceDate: formData.clearanceDate ? dayjs(formData.clearanceDate).format('YYYY-MM-DD') : null,
            };

            const url = `api/exit/clearance/it/${clearanceData.exitClearanceId}`;
            const response = await PUT(url, updateData, {
                headers: { Authorization: `Bearer ${jwtToken}` },
            });

            if (response.status === 200) {
                setSnackMessage('IT clearance updated successfully');
                setSnackColor('success');
                setSnackOpen(true);

                if (shouldApprove && signatureForApproval) {
                    await performApproval(signatureForApproval);
                } else {
                    setTimeout(() => {
                        onSuccess();
                        onClose();
                    }, 1500);
                }
            }
        } catch (error) {
            setSnackMessage(error.response?.data?.message || 'Failed to update');
            setSnackColor('error');
            setSnackOpen(true);
        } finally {
            setUpdateLoading(false);
            setApproveLoading(false);
        }
    };

    const performApproval = async (signature) => {
        try {
            const jwtToken = window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token');
            const requestBody = { managerSignature: signature };

            const response = await POST(
                `api/exit/clearance/it/${clearanceData.exitClearanceId}/approve`,
                requestBody,
                { headers: { Authorization: `Bearer ${jwtToken}` } }
            );

            if (response.status === 200) {
                setSnackMessage('IT clearance updated and approved successfully');
                setSnackColor('success');
                setSnackOpen(true);
                setTimeout(() => {
                    onSuccess();
                    onClose();
                }, 2000);
            }
        } catch (error) {
            setSnackMessage(error.response?.data?.message || 'Failed to approve IT clearance');
            setSnackColor('error');
            setSnackOpen(true);
        } finally {
            setApproveLoading(false);
            setUpdateLoading(false);
        }
    };

    const handleSignatureDialogConfirm = async () => {
        if (signatureChoice === 'new' && !newSignature) {
            setSnackMessage('Please upload a new signature');
            setSnackColor('error');
            setSnackOpen(true);
            return;
        }

        setOpenSignatureDialog(false);

        const signatureToUse = signatureChoice === 'existing' ? existingSignature : newSignature;

        await performUpdate(signatureToUse, true);
    };

    const handleSignatureDialogCancel = () => {
        setOpenSignatureDialog(false);
        setSignatureChoice('existing');
        setNewSignature(null);
    };

    const sectionCardStyle = {
        p: 2.5,
        mb: 2,
        backgroundColor: '#f5f7fa',
        borderRadius: 2,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    };

    if (!open) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" scroll="paper">
            <DialogTitle sx={{ p: 0 }}>
                <MDBox
                    variant="gradient"
                    sx={{ background: properties.colors.bgcolorbluethem }}
                    borderRadius="lg"
                    p={3}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        IT Clearance Form
                    </MDTypography>
                    <MDTypography variant="body2" color="white" opacity={0.8}>
                        Update IT clearance details and approve
                    </MDTypography>
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            position: 'absolute',
                            right: 12,
                            top: 12,
                            color: 'white',
                        }}
                    >
                        <Close />
                    </IconButton>
                </MDBox>
            </DialogTitle>

            <DialogContent dividers sx={{ p: 0 }}>
                <MDBox pt={4} pb={3}>
                    <Card>
                        <MDBox pt={4} pb={3} px={3}>
                            {isAlreadyApproved && (
                                <Card
                                    sx={{
                                        p: 2,
                                        mb: 3,
                                        backgroundColor: '#fff3cd',
                                        border: '2px solid #ffc107',
                                    }}
                                >
                                    <MDBox display="flex" alignItems="center">
                                        <Warning sx={{ color: '#ff9800', mr: 1 }} />
                                        <MDTypography
                                            variant="body2"
                                            color="text"
                                            fontWeight="bold"
                                        >
                                            Notice: This clearance was previously approved. If you make changes, you will need to re-approve with a signature.
                                        </MDTypography>
                                    </MDBox>
                                </Card>
                            )}

                            <Card
                                sx={{
                                    p: 2,
                                    mb: 3,
                                    backgroundColor: '#fff3cd',
                                    border: '1px solid #ffc107',
                                }}
                            >
                                <MDTypography
                                    variant="body2"
                                    color="text"
                                    textAlign="center"
                                    fontWeight="medium"
                                >
                                    An employee is required to return the Company&apos;s
                                    properties to the respective Department&apos;s before leaving
                                    the Company. He/She is instructed to bring the form to the
                                    various Departments as stated below to obtain Clearance before
                                    exit.
                                </MDTypography>
                            </Card>

                            <form onSubmit={(e) => handleSubmit(e, false)}>
                                <Grid container spacing={2}>
                                    {/* Employee Information Cards */}
                                    <Grid item xs={12}>
                                        <Card sx={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0', mb: 2 }}>
                                            <MDBox p={3}>
                                                <MDBox display="flex" alignItems="center" mb={2}>
                                                    <Box
                                                        sx={{
                                                            width: 4,
                                                            height: 24,
                                                            backgroundColor: '#1A73E8',
                                                            borderRadius: 1,
                                                            mr: 1.5
                                                        }}
                                                    />
                                                    <MDTypography variant="h6" fontWeight="bold" color="info">
                                                        Personal Information
                                                    </MDTypography>
                                                </MDBox>
                                                <Grid container spacing={2.5}>
                                                    <Grid item xs={12} md={3}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Name
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.employeeName || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Employee ID
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.employeeId || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Designation
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.designation || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Technology
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.technology || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                </Grid>
                                            </MDBox>
                                        </Card>

                                        <Card sx={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0', mb: 2 }}>
                                            <MDBox p={3}>
                                                <MDBox display="flex" alignItems="center" mb={2}>
                                                    <Box
                                                        sx={{
                                                            width: 4,
                                                            height: 24,
                                                            backgroundColor: '#1A73E8',
                                                            borderRadius: 1,
                                                            mr: 1.5
                                                        }}
                                                    />
                                                    <MDTypography variant="h6" fontWeight="bold" color="info">
                                                        Project Details
                                                    </MDTypography>
                                                </MDBox>
                                                <Grid container spacing={2.5}>
                                                    <Grid item xs={12} md={4}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Project Name
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.projectName || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Reporting Manager
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.projectManager || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Knowledge Transfer
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.knowledgeTransfer || 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                </Grid>
                                            </MDBox>
                                        </Card>

                                        <Card sx={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
                                            <MDBox p={3}>
                                                <MDBox display="flex" alignItems="center" mb={2}>
                                                    <Box
                                                        sx={{
                                                            width: 4,
                                                            height: 24,
                                                            backgroundColor: '#1A73E8',
                                                            borderRadius: 1,
                                                            mr: 1.5
                                                        }}
                                                    />
                                                    <MDTypography variant="h6" fontWeight="bold" color="info">
                                                        Exit Information
                                                    </MDTypography>
                                                </MDBox>
                                                <Grid container spacing={2.5}>
                                                    <Grid item xs={12} md={4}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Date of Joining
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.dateOfJoining
                                                                    ? new Date(clearanceData.dateOfJoining).toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: '2-digit',
                                                                    })
                                                                    : 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Date of Leaving
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.dateOfLeaving
                                                                    ? new Date(clearanceData.dateOfLeaving).toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: '2-digit',
                                                                    })
                                                                    : 'N/A'}
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <MDBox>
                                                            <MDTypography variant="caption" color="text" fontWeight="medium" sx={{ opacity: 0.7 }}>
                                                                Notice Period Served
                                                            </MDTypography>
                                                            <MDTypography variant="h6" fontWeight="medium" mt={0.5}>
                                                                {clearanceData?.noticePeriodServed || 'N/A'} days
                                                            </MDTypography>
                                                        </MDBox>
                                                    </Grid>
                                                </Grid>
                                            </MDBox>
                                        </Card>
                                    </Grid>



                                    <Grid item xs={12}>
                                        <Card sx={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0', mb: 2 }}>
                                            <MDBox p={3}>
                                                <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                    <MDBox display="flex" alignItems="center">
                                                        <Box
                                                            sx={{
                                                                width: 4,
                                                                height: 24,
                                                                backgroundColor: '#1A73E8',
                                                                borderRadius: 1,
                                                                mr: 1.5
                                                            }}
                                                        />
                                                        <MDTypography variant="h6" fontWeight="bold" color="info">
                                                            Employee Assets
                                                        </MDTypography>
                                                    </MDBox>
                                                    {assetsLoading && <CircularProgress size={20} />}
                                                </MDBox>

                                                {employeeAssets.length === 0 && !assetsLoading ? (
                                                    <MDBox textAlign="center" py={2}>
                                                        <MDTypography variant="body2" color="text.secondary">
                                                            No assets assigned to this employee
                                                        </MDTypography>
                                                    </MDBox>
                                                ) : (
                                                    <Box>
                                                        {/* Table Header */}
                                                        <Grid
                                                            container
                                                            spacing={2}
                                                            sx={{
                                                                backgroundColor: '#f5f5f5',
                                                                py: 1.5,
                                                                px: 2,
                                                                borderRadius: 1,
                                                                mb: 1
                                                            }}
                                                        >
                                                            <Grid item xs={2}>
                                                                <Typography variant="body2" fontWeight="bold">Asset No</Typography>
                                                            </Grid>
                                                            <Grid item xs={2.5}>
                                                                <Typography variant="body2" fontWeight="bold">Asset Name</Typography>
                                                            </Grid>
                                                            <Grid item xs={1.5}>
                                                                <Typography variant="body2" fontWeight="bold">Component</Typography>
                                                            </Grid>
                                                            <Grid item xs={1.5}>
                                                                <Typography variant="body2" fontWeight="bold">Assigned Date</Typography>
                                                            </Grid>
                                                            <Grid item xs={1.5}>
                                                                <Typography variant="body2" fontWeight="bold">Assigned By</Typography>
                                                            </Grid>
                                                            <Grid item xs={1.5}>
                                                                <Typography variant="body2" fontWeight="bold">Status</Typography>
                                                            </Grid>
                                                            <Grid item xs={1.5}>
                                                                <Typography variant="body2" fontWeight="bold">Return Details</Typography>
                                                            </Grid>
                                                        </Grid>

                                                        {/* Table Rows */}
                                                        {employeeAssets.map((asset, index) => (
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                                key={index}
                                                                sx={{
                                                                    py: 1.5,
                                                                    px: 2,
                                                                    borderBottom: '1px solid #e0e0e0',
                                                                    backgroundColor: asset.returnedDate ? 'transparent' : '#fff3cd',
                                                                    alignItems: 'center',
                                                                    '&:hover': {
                                                                        backgroundColor: asset.returnedDate ? '#f9f9f9' : '#ffe9a0'
                                                                    }
                                                                }}
                                                            >
                                                                <Grid item xs={2}>
                                                                    <Tooltip title={asset.assetNo} arrow>
                                                                        <Typography
                                                                            variant="body2"
                                                                            fontWeight="medium"
                                                                            sx={{
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                        >
                                                                            {asset.assetNo}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                </Grid>
                                                                <Grid item xs={2.5}>
                                                                    <Tooltip title={asset.assetName} arrow>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                        >
                                                                            {asset.assetName}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                </Grid>
                                                                <Grid item xs={1.5}>
                                                                    <Tooltip title={asset.componentName} arrow>
                                                                        <Chip
                                                                            label={asset.componentName}
                                                                            size="small"
                                                                            color="primary"
                                                                            variant="outlined"
                                                                            sx={{
                                                                                fontSize: '0.7rem',
                                                                                height: 22,
                                                                                maxWidth: '100%',
                                                                                '& .MuiChip-label': {
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                </Grid>
                                                                <Grid item xs={1.5}>
                                                                    <Tooltip title={asset.assignedDate ? dayjs(asset.assignedDate).format('DD MMM YYYY') : 'N/A'} arrow>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                        >
                                                                            {asset.assignedDate
                                                                                ? dayjs(asset.assignedDate).format('DD MMM YY')
                                                                                : 'N/A'}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                </Grid>
                                                                <Grid item xs={1.5}>
                                                                    <Tooltip title={asset.assignedBy || 'N/A'} arrow>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                        >
                                                                            {asset.assignedBy || 'N/A'}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                </Grid>
                                                                <Grid item xs={1.5}>
                                                                    {asset.returnedDate ? (
                                                                        <Chip
                                                                            icon={<CheckCircle sx={{ fontSize: 14 }} />}
                                                                            label="Returned"
                                                                            size="small"
                                                                            sx={{
                                                                                backgroundColor: '#e8f5e9',
                                                                                color: '#2e7d32',
                                                                                fontWeight: 600,
                                                                                fontSize: '0.7rem',
                                                                                height: 22
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Tooltip title="Not Returned" arrow>
                                                                            <Chip
                                                                                icon={<Cancel sx={{ fontSize: 14 }} />}
                                                                                label="Not Returned"
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: '#ffebee',
                                                                                    color: '#c62828',
                                                                                    fontWeight: 600,
                                                                                    fontSize: '0.7rem',
                                                                                    height: 22,
                                                                                    maxWidth: '100%',
                                                                                    '& .MuiChip-label': {
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        whiteSpace: 'nowrap'
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                                </Grid>
                                                                <Grid item xs={1.5}>
                                                                    {asset.returnedDate ? (
                                                                        <Tooltip
                                                                            title={
                                                                                <Box>
                                                                                    <Typography variant="caption" display="block">
                                                                                        Returned: {dayjs(asset.returnedDate).format('DD MMM YYYY')}
                                                                                    </Typography>
                                                                                    <Typography variant="caption" display="block">
                                                                                        To: {asset.returnTo || 'N/A'}
                                                                                    </Typography>
                                                                                    {asset.returnReason && (
                                                                                        <Typography variant="caption" display="block">
                                                                                            Reason: {asset.returnReason}
                                                                                        </Typography>
                                                                                    )}
                                                                                </Box>
                                                                            }
                                                                            arrow
                                                                        >
                                                                            <Box>
                                                                                <Typography
                                                                                    variant="caption"
                                                                                    display="block"
                                                                                    sx={{
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        whiteSpace: 'nowrap'
                                                                                    }}
                                                                                >
                                                                                    {dayjs(asset.returnedDate).format('DD MMM YY')}
                                                                                </Typography>
                                                                                <Typography
                                                                                    variant="caption"
                                                                                    display="block"
                                                                                    color="text.secondary"
                                                                                    sx={{
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        whiteSpace: 'nowrap'
                                                                                    }}
                                                                                >
                                                                                    To: {asset.returnTo || 'N/A'}
                                                                                </Typography>
                                                                                {asset.returnReason && (
                                                                                    <Typography
                                                                                        variant="caption"
                                                                                        display="block"
                                                                                        color="text.secondary"
                                                                                        sx={{
                                                                                            fontStyle: 'italic',
                                                                                            overflow: 'hidden',
                                                                                            textOverflow: 'ellipsis',
                                                                                            whiteSpace: 'nowrap'
                                                                                        }}
                                                                                    >
                                                                                        {asset.returnReason}
                                                                                    </Typography>
                                                                                )}
                                                                            </Box>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Typography variant="caption" color="error">
                                                                            Not yet returned
                                                                        </Typography>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                    </Box>
                                                )}
                                            </MDBox>
                                        </Card>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Card
                                            sx={{
                                                p: 2,
                                                mb: 2,
                                                backgroundColor: '#e7f3ff',
                                                border: '1px solid #2196f3',
                                            }}
                                        >
                                            <MDTypography variant="body2" color="text" fontWeight="medium">
                                                Person in-charge is required to sign-off in the respective
                                                sections mentioned below. Advising team and Reporting
                                                Manager should sign after rest of the clearances.
                                            </MDTypography>
                                        </Card>
                                    </Grid>

                                    {/* IT Department Clearance */}
                                    <Grid item xs={12}>
                                        <Card sx={sectionCardStyle}>
                                            <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                                                IT Department Clearance
                                            </MDTypography>
                                            <MDTypography variant="caption" color="text.secondary">
                                                Please submit all following things to concern departments.
                                            </MDTypography>

                                            <Grid container spacing={2} sx={{ mt: 1, alignItems: 'center' }}>
                                                {/* Header */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2" fontWeight="bold">Particulars</Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <Typography variant="body2" fontWeight="bold">Status <span style={{ color: '#d32f2f' }}>*</span></Typography>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2" fontWeight="bold">Employee Comment</Typography>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2" fontWeight="bold">Department Comment <span style={{ color: '#d32f2f' }}>*</span></Typography>
                                                </Grid>

                                                {/* Email Deletion */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2">
                                                        Deletion of email id
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FormControl
                                                        fullWidth
                                                        variant="standard"
                                                        error={validationErrors.emailDeletion}
                                                    >
                                                        <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                                                        <Select
                                                            value={formData.emailDeletion || ''}
                                                            onChange={(e) =>
                                                                handleNestedChange('emailDeletion', e.target.value)
                                                            }
                                                            disabled={readOnly}
                                                        >
                                                            {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                                            <MenuItem value="N/A">N/A</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Submitted">Submitted</MenuItem>
                                                        </Select>
                                                        {validationErrors.emailDeletion && (
                                                            <FormHelperText>Please select a status</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.empEmailIdComment}
                                                        disabled
                                                        placeholder="Employee comment"
                                                        sx={{
                                                            '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                                                backgroundColor: '#f5f5f5',
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.departmentEmailIdComment}
                                                        onChange={(e) => handleNestedChange('departmentEmailIdComment', e.target.value)}
                                                        placeholder="Enter department comment"
                                                        disabled={readOnly}
                                                        error={validationErrors.departmentEmailIdComment}
                                                        helperText={validationErrors.departmentEmailIdComment ? 'Department comment is required' : ''}
                                                    />
                                                </Grid>

                                                {/* Email Retention - NEW SEPARATE ROW */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2">
                                                        Retention of email id
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FormControl
                                                        fullWidth
                                                        variant="standard"
                                                        error={validationErrors.emailRetention}
                                                    >
                                                        <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                                                        <Select
                                                            value={formData.emailRetention || ''}
                                                            onChange={(e) =>
                                                                handleNestedChange('emailRetention', e.target.value)
                                                            }
                                                            disabled={readOnly}
                                                        >
                                                            {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                                            <MenuItem value="N/A">N/A</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Submitted">Submitted</MenuItem>
                                                        </Select>
                                                        {validationErrors.emailRetention && (
                                                            <FormHelperText>Please select a status</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.empEmailRetentionComment}
                                                        disabled
                                                        placeholder="Employee comment"
                                                        sx={{
                                                            '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                                                backgroundColor: '#f5f5f5',
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.departmentEmailRetentionComment}
                                                        onChange={(e) => handleNestedChange('departmentEmailRetentionComment', e.target.value)}
                                                        placeholder="Enter department comment"
                                                        disabled={readOnly}
                                                        error={validationErrors.departmentEmailRetentionComment}
                                                        helperText={validationErrors.departmentEmailRetentionComment ? 'Department comment is required' : ''}
                                                    />
                                                </Grid>

                                                {/* Laptop */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2">Laptop, mouse, charger returned </Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FormControl
                                                        fullWidth
                                                        variant="standard"
                                                        error={validationErrors.laptopReturned}
                                                    >
                                                        <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                                                        <Select
                                                            value={formData.laptopReturned || ''}
                                                            onChange={(e) =>
                                                                handleNestedChange('laptopReturned', e.target.value)
                                                            }
                                                            disabled={readOnly}
                                                        >
                                                            {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                                            <MenuItem value="N/A">N/A</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Submitted">Submitted</MenuItem>
                                                        </Select>
                                                        {validationErrors.laptopReturned && (
                                                            <FormHelperText>Please select a status</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.empLaptopReturnedComment}
                                                        disabled
                                                        placeholder="Employee comment"
                                                        sx={{
                                                            '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                                                backgroundColor: '#f5f5f5',
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.departmentLaptopReturnedComment}
                                                        onChange={(e) => handleNestedChange('departmentLaptopReturnedComment', e.target.value)}
                                                        placeholder="Enter department comment"
                                                        disabled={readOnly}
                                                        error={validationErrors.departmentLaptopReturnedComment}
                                                        helperText={validationErrors.departmentLaptopReturnedComment ? 'Department comment is required' : ''}
                                                    />
                                                </Grid>

                                                {/* System Login */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2">
                                                        System login id deactivated
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FormControl
                                                        fullWidth
                                                        variant="standard"
                                                        error={validationErrors.systemLoginDeactivated}
                                                    >
                                                        <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                                                        <Select
                                                            value={formData.systemLoginDeactivated || ''}
                                                            onChange={(e) =>
                                                                handleNestedChange(
                                                                    'systemLoginDeactivated',
                                                                    e.target.value
                                                                )
                                                            }
                                                            disabled={readOnly}
                                                        >
                                                            {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                                            <MenuItem value="N/A">N/A</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Submitted">Submitted</MenuItem>
                                                        </Select>
                                                        {validationErrors.systemLoginDeactivated && (
                                                            <FormHelperText>Please select a status</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.empSystemLoginComment}
                                                        disabled
                                                        placeholder="Employee comment"
                                                        sx={{
                                                            '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                                                backgroundColor: '#f5f5f5',
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.departmentSystemLoginComment}
                                                        onChange={(e) => handleNestedChange('departmentSystemLoginComment', e.target.value)}
                                                        placeholder="Enter department comment"
                                                        disabled={readOnly}
                                                        error={validationErrors.departmentSystemLoginComment}
                                                        helperText={validationErrors.departmentSystemLoginComment ? 'Department comment is required' : ''}
                                                    />
                                                </Grid>

                                                {/* Biometric */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2">Bio Metric entry (delete)</Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FormControl
                                                        fullWidth
                                                        variant="standard"
                                                        error={validationErrors.biometricDeleted}
                                                    >
                                                        <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                                                        <Select
                                                            value={formData.biometricDeleted || ''}
                                                            onChange={(e) =>
                                                                handleNestedChange('biometricDeleted', e.target.value)
                                                            }
                                                            disabled={readOnly}
                                                        >
                                                            {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                                            <MenuItem value="N/A">N/A</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Submitted">Submitted</MenuItem>
                                                        </Select>
                                                        {validationErrors.biometricDeleted && (
                                                            <FormHelperText>Please select a status</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.empBiometricComment}
                                                        disabled
                                                        placeholder="Employee comment"
                                                        sx={{
                                                            '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                                                backgroundColor: '#f5f5f5',
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.departmentBiometricComment}
                                                        onChange={(e) => handleNestedChange('departmentBiometricComment', e.target.value)}
                                                        placeholder="Enter department comment"
                                                        disabled={readOnly}
                                                        error={validationErrors.departmentBiometricComment}
                                                        helperText={validationErrors.departmentBiometricComment ? 'Department comment is required' : ''}
                                                    />
                                                </Grid>

                                                {/* Backup CD */}
                                                <Grid item xs={12} md={3}>
                                                    <Typography variant="body2">Company Mobile/Devices submitted</Typography>
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FormControl
                                                        fullWidth
                                                        variant="standard"
                                                        error={validationErrors.backupCdReturned}
                                                    >
                                                        <InputLabel sx={{ mt: -1 }}>Select Status</InputLabel>
                                                        <Select
                                                            value={formData.backupCdReturned || ''}
                                                            onChange={(e) =>
                                                                handleNestedChange('backupCdReturned', e.target.value)
                                                            }
                                                            disabled={readOnly}
                                                        >
                                                            {/* <MenuItem value="" disabled>Select Status</MenuItem> */}
                                                            <MenuItem value="N/A">N/A</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="Submitted">Submitted</MenuItem>
                                                        </Select>
                                                        {validationErrors.backupCdReturned && (
                                                            <FormHelperText>Please select a status</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.empBackupCdComment}
                                                        disabled
                                                        placeholder="Employee comment"
                                                        sx={{
                                                            '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                                                                backgroundColor: '#f5f5f5',
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={formData.departmentBackupCdComment}
                                                        onChange={(e) => handleNestedChange('departmentBackupCdComment', e.target.value)}
                                                        placeholder="Enter department comment"
                                                        disabled={readOnly}
                                                        error={validationErrors.departmentBackupCdComment}
                                                        helperText={validationErrors.departmentBackupCdComment ? 'Department comment is required' : ''}
                                                    />
                                                </Grid>

                                                {/* Additional Items */}
                                                <Grid item xs={12}>
                                                    <AdditionalItemsSection
                                                        items={formData.additionalItem}
                                                        handleAdditionalItemChange={handleAdditionalItemChange}
                                                        handleRemoveAdditionalItem={handleRemoveAdditionalItem}
                                                        handleAddAdditionalItem={handleAddAdditionalItem}
                                                        validationErrors={validationErrors}
                                                        disabled={readOnly}
                                                    />
                                                </Grid>

                                                {/* Clearance Date */}
                                                <Grid item xs={12} md={2}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            format="DD/MM/YYYY"
                                                            label="Date"
                                                            value={
                                                                formData.clearanceDate
                                                                    ? dayjs(formData.clearanceDate)
                                                                    : null
                                                            }
                                                            slotProps={{
                                                                textField: { variant: 'standard', fullWidth: true },
                                                            }}
                                                            readOnly
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>

                                    {/* Approved By Section - Show only if signature exists */}
                                    {existingSignature && (
                                        <Grid item xs={12}>
                                            <Card
                                                sx={{
                                                    p: 3,
                                                    mb: 3,
                                                    backgroundColor: '#e8f5e8',
                                                    border: '2px solid #4caf50',
                                                    borderRadius: 2,
                                                    boxShadow: '0 4px 12px rgba(76, 175, 80, 0.15)',
                                                }}
                                            >
                                                <MDBox display="flex" alignItems="center" justifyContent="space-between">
                                                    <MDBox display="flex" alignItems="center">
                                                        <CheckCircleIcon sx={{ fontSize: 40, color: '#2e7d32', mr: 2 }} />
                                                        <MDBox>
                                                            <MDTypography variant="h6" fontWeight="bold" color="success">
                                                                Clearance Approved
                                                            </MDTypography>
                                                            <MDTypography variant="body2" color="text.secondary">
                                                                This IT clearance has been approved and signed off.
                                                            </MDTypography>
                                                            {clearanceData.approvedBy && (
                                                                <MDTypography variant="body2" fontWeight="medium" color="text.primary" mt={0.5}>
                                                                    Approved by: <strong>{clearanceData.approvedBy}</strong>
                                                                </MDTypography>
                                                            )}
                                                            {clearanceData.approvedAt && (
                                                                <MDTypography variant="caption" color="text.secondary">
                                                                    on {new Date(clearanceData.approvedAt).toLocaleDateString('en-GB', {
                                                                        day: '2-digit',
                                                                        month: 'long',
                                                                        year: 'numeric',
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                    })}
                                                                </MDTypography>
                                                            )}
                                                        </MDBox>
                                                    </MDBox>

                                                    {/* Signature Image */}
                                                    <MDBox
                                                        sx={{
                                                            p: 2,
                                                            backgroundColor: 'white',
                                                            borderRadius: 2,
                                                            border: '1px solid #a5d6a7',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                existingSignature.startsWith('data:')
                                                                    ? existingSignature
                                                                    : `data:image/png;base64,${existingSignature}`
                                                            }
                                                            alt="Manager Signature"
                                                            style={{
                                                                maxHeight: '80px',
                                                                maxWidth: '250px',
                                                                objectFit: 'contain',
                                                            }}
                                                        />
                                                        <MDTypography variant="caption" display="block" textAlign="center" mt={1} color="success">
                                                            Manager Signature
                                                        </MDTypography>
                                                    </MDBox>
                                                </MDBox>
                                            </Card>
                                        </Grid>
                                    )}

                                    {/* Submit Buttons */}
                                    {!readOnly && (
                                    <Grid item xs={12}>
                                        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                                            <MDButton variant="outlined" color="secondary" onClick={onClose} disabled={updateLoading || approveLoading}>
                                                Cancel
                                            </MDButton>

                                            {/* Update Only Button */}
                                            <MDButton
                                                variant="gradient"
                                                color="info"
                                                type="submit"
                                                disabled={updateLoading || approveLoading || readOnly}
                                                sx={{ background: properties.colors.bgcolorbluethem, ml: 2 }}
                                            >
                                                {updateLoading ? (
                                                    <>
                                                        <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                                                        Updating...
                                                    </>
                                                ) : (
                                                    'Update IT Clearance Form'
                                                )}
                                            </MDButton>

                                            {/* Update & Approve Button */}
                                            <MDButton
                                                variant="gradient"
                                                color="success"
                                                onClick={(e) => handleSubmit(e, true)}
                                                disabled={updateLoading || approveLoading || readOnly}
                                                sx={{
                                                    background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
                                                    ml: 2,
                                                }}
                                            >
                                                {approveLoading ? (
                                                    <>
                                                        <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                                                        Approving...
                                                    </>
                                                ) : (
                                                    'Update & Approve'
                                                )}
                                            </MDButton>
                                        </DialogActions>
                                    </Grid>
                                    )}
                                </Grid>
                            </form>

                            <Snackbar
                                open={snackOpen}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                autoHideDuration={6000} // Increased from 3000 to give more time to read pending items
                                onClose={() => setSnackOpen(false)}
                            >
                                <Alert
                                    onClose={() => setSnackOpen(false)}
                                    severity={snackColor === 'success' ? 'success' : snackColor === 'warning' ? 'warning' : 'error'}
                                    variant="filled"
                                    sx={{
                                        width: '100%',
                                        color: '#fff',
                                        whiteSpace: 'pre-line', // Allow line breaks in message
                                        maxWidth: '500px' // Wider alert for better readability
                                    }}
                                >
                                    {snackMessage}
                                </Alert>
                            </Snackbar>
                        </MDBox>
                    </Card>

                    <Box mt={2} mb={4} textAlign="center">
                        <Typography variant="caption" color="text.secondary">
                            BNT SOFT PVT. LTD. Office No. 301-304, &quot;A&quot; Building,
                            Pune IT Park, 34, Aundh Road, Bhau Patil Marg, Bopodi, Pune-411020,
                            Maharashtra, India. Web: www.bnt-soft.com
                        </Typography>
                    </Box>
                </MDBox>
            </DialogContent>

            {/* Simple Signature Dialog - First Time Approval */}
            <Dialog
                open={openSimpleSignatureDialog}
                onClose={() => setOpenSimpleSignatureDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ background: '#1976d2', color: 'white' }}>
                    <Typography variant="h6">Approve IT Clearance</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ textAlign: 'center', py: 3 }}>
                        {newSignature ? (
                            <Box>
                                <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                                <img src={newSignature} alt="Signature" style={{ maxHeight: 120, mt: 2 }} />
                                <IconButton onClick={handleRemoveNewSignature} color="error">
                                    <Delete />
                                </IconButton>
                            </Box>
                        ) : (
                            <>
                                <CloudUpload sx={{ fontSize: 64, color: '#1976d2', mb: 2 }} />
                                <Typography variant="h6" gutterBottom>Upload Your Signature</Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    Required to approve this clearance
                                </Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUpload />}
                                    sx={{ color: "#fff" }}
                                >
                                    Upload Signature
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*"
                                        onChange={handleNewSignatureUpload}
                                    />
                                </Button>
                            </>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenSimpleSignatureDialog(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        disabled={!newSignature || loading}
                        onClick={async () => {
                            setOpenSimpleSignatureDialog(false);
                            await performUpdate(newSignature, true);
                        }}
                        sx={{
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            '&:hover': {
                                backgroundColor: "#115293",
                            }
                        }}
                    >
                        {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : 'Approve Clearance'}
                    </Button>

                </DialogActions>
            </Dialog>

            {/* Signature Selection Dialog */}
            <Dialog
                open={openSignatureDialog}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    handleSignatureDialogCancel();
                }}
                maxWidth="md"
                fullWidth
                disableEscapeKeyDown
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        py: 3,
                        position: 'relative',
                    }}
                >
                    <MDBox>
                        <MDBox display="flex" alignItems="center" mb={1}>
                            <Warning sx={{ fontSize: 32, mr: 1.5 }} />
                            <MDTypography variant="h4" fontWeight="bold" color="white">
                                Re-approval Required
                            </MDTypography>
                        </MDBox>
                        <MDTypography variant="body2" color="white" sx={{ opacity: 0.95, ml: 5.5 }}>
                            Changes detected - signature verification needed
                        </MDTypography>
                    </MDBox>
                    <IconButton
                        onClick={handleSignatureDialogCancel}
                        size="small"
                        sx={{
                            position: 'absolute',
                            right: 16,
                            top: 16,
                            color: 'white',
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            '&:hover': {
                                backgroundColor: 'rgba(255,255,255,0.3)',
                            }
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ p: 4, backgroundColor: '#f8f9fa' }}>
                    <Alert
                        severity="warning"
                        icon={<Warning />}
                        sx={{
                            mb: 4,
                            borderRadius: 2,
                            border: '1px solid #ffc107',
                            '& .MuiAlert-icon': {
                                fontSize: 28,
                            }
                        }}
                    >
                        <Typography variant="body1" fontWeight="medium" gutterBottom>
                            This clearance was previously approved
                        </Typography>
                        <Typography variant="body2">
                            Since you&apos;ve made changes to the clearance data, you need to re-approve it with a valid signature to maintain audit compliance.
                        </Typography>
                    </Alert>

                    {existingSignature && existingEmpId === empId ? (
                        <>
                            <Card
                                sx={{
                                    mb: 3,
                                    p: 3,
                                    backgroundColor: 'white',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                }}
                            >
                                <MDBox display="flex" alignItems="center" mb={2}>
                                    <Box
                                        sx={{
                                            width: 6,
                                            height: 24,
                                            backgroundColor: '#667eea',
                                            borderRadius: 1,
                                            mr: 1.5
                                        }}
                                    />
                                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                                        Your Previous Signature
                                    </Typography>
                                </MDBox>

                                <Box
                                    sx={{
                                        display: 'inline-block',
                                        p: 2.5,
                                        border: '2px solid #e0e0e0',
                                        borderRadius: 2,
                                        backgroundColor: '#fafafa',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <img
                                        src={existingSignature.startsWith('data:')
                                            ? existingSignature
                                            : `data:image/png;base64,${existingSignature}`
                                        }
                                        alt="Existing Signature"
                                        style={{
                                            maxWidth: '350px',
                                            maxHeight: '150px',
                                            display: 'block',
                                        }}
                                    />
                                </Box>
                            </Card>

                            <Card
                                sx={{
                                    p: 3,
                                    backgroundColor: 'white',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                }}
                            >
                                <MDBox display="flex" alignItems="center" mb={2}>
                                    <Box
                                        sx={{
                                            width: 6,
                                            height: 24,
                                            backgroundColor: '#667eea',
                                            borderRadius: 1,
                                            mr: 1.5
                                        }}
                                    />
                                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                                        Choose Signature Option
                                    </Typography>
                                </MDBox>

                                <RadioGroup
                                    value={signatureChoice}
                                    onChange={(e) => setSignatureChoice(e.target.value)}
                                >
                                    <FormControlLabel
                                        value="existing"
                                        control={<Radio sx={{ color: '#667eea', '&.Mui-checked': { color: '#667eea' } }} />}
                                        label={
                                            <Box sx={{ ml: 1 }}>
                                                <Typography variant="body1" fontWeight="medium">
                                                    Use existing signature
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    Reuse the signature shown above
                                                </Typography>
                                            </Box>
                                        }
                                        sx={{
                                            mb: 2,
                                            p: 2,
                                            border: signatureChoice === 'existing' ? '2px solid #667eea' : '2px solid #e0e0e0',
                                            borderRadius: 2,
                                            backgroundColor: signatureChoice === 'existing' ? '#f3f4ff' : 'transparent',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                borderColor: '#667eea',
                                                backgroundColor: '#f3f4ff',
                                            }
                                        }}
                                    />
                                    <FormControlLabel
                                        value="new"
                                        control={<Radio sx={{ color: '#667eea', '&.Mui-checked': { color: '#667eea' } }} />}
                                        label={
                                            <Box sx={{ ml: 1 }}>
                                                <Typography variant="body1" fontWeight="medium">
                                                    Upload new signature
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    Provide a fresh signature image
                                                </Typography>
                                            </Box>
                                        }
                                        sx={{
                                            p: 2,
                                            border: signatureChoice === 'new' ? '2px solid #667eea' : '2px solid #e0e0e0',
                                            borderRadius: 2,
                                            backgroundColor: signatureChoice === 'new' ? '#f3f4ff' : 'transparent',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                borderColor: '#667eea',
                                                backgroundColor: '#f3f4ff',
                                            }
                                        }}
                                    />
                                </RadioGroup>

                                {signatureChoice === 'new' && (
                                    <Box sx={{ mt: 3, p: 3, backgroundColor: '#f8f9fa', borderRadius: 2, border: '1px dashed #667eea' }}>
                                        {newSignature ? (
                                            <Box>
                                                <MDBox display="flex" alignItems="center" mb={2}>
                                                    <CheckCircleIcon sx={{ color: '#4caf50', mr: 1 }} />
                                                    <Typography variant="body1" color="success.main" fontWeight="bold">
                                                        New signature uploaded successfully!
                                                    </Typography>
                                                </MDBox>
                                                <Box
                                                    sx={{
                                                        display: 'inline-block',
                                                        p: 2.5,
                                                        border: '3px solid #4caf50',
                                                        borderRadius: 2,
                                                        backgroundColor: '#f1f8f4',
                                                        position: 'relative',
                                                        boxShadow: '0 4px 12px rgba(76,175,80,0.2)',
                                                    }}
                                                >
                                                    <img
                                                        src={newSignature}
                                                        alt="New Signature"
                                                        style={{
                                                            maxWidth: '350px',
                                                            maxHeight: '150px',
                                                            display: 'block',
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        onClick={handleRemoveNewSignature}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: -12,
                                                            right: -12,
                                                            bgcolor: 'white',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                            '&:hover': {
                                                                bgcolor: '#ffebee',
                                                            }
                                                        }}
                                                    >
                                                        <Delete fontSize="small" color="error" />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box sx={{ textAlign: 'center', py: 2 }}>
                                                <CloudUpload sx={{ fontSize: 56, color: '#667eea', mb: 2 }} />
                                                <Typography variant="h6" color="text.primary" mb={1} fontWeight="medium">
                                                    Upload Your Signature
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" mb={3}>
                                                    Accepted formats: JPG, PNG, GIF (Max 2MB)
                                                </Typography>
                                                <Button
                                                    variant="contained"
                                                    component="label"
                                                    startIcon={<CloudUpload />}
                                                    sx={{
                                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                        color: '#fff',
                                                        py: 1.5,
                                                        px: 4,
                                                        borderRadius: 2,
                                                        textTransform: 'none',
                                                        fontSize: '1rem',
                                                        fontWeight: 600,
                                                        boxShadow: '0 4px 12px rgba(102,126,234,0.4)',
                                                        '&:hover': {
                                                            background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
                                                            boxShadow: '0 6px 16px rgba(102,126,234,0.5)',
                                                        },
                                                    }}
                                                >
                                                    Choose File
                                                    <input
                                                        type="file"
                                                        hidden
                                                        accept="image/*"
                                                        onChange={handleNewSignatureUpload}
                                                    />
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                )}
                            </Card>
                        </>
                    ) : (
                        <>
                            <Alert
                                severity="info"
                                sx={{
                                    mb: 3,
                                    borderRadius: 2,
                                    backgroundColor: '#e3f2fd',
                                    border: '1px solid #2196f3',
                                }}
                            >
                                <Typography variant="body2" fontWeight="medium">
                                    Previous signature cannot be reused as it belongs to a different user. Please upload your signature to proceed.
                                </Typography>
                            </Alert>

                            <Card
                                sx={{
                                    p: 3,
                                    backgroundColor: 'white',
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    border: '2px dashed #667eea',
                                }}
                            >
                                {newSignature ? (
                                    <Box>
                                        <MDBox display="flex" alignItems="center" mb={2}>
                                            <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 28, mr: 1.5 }} />
                                            <Typography variant="h6" color="success.main" fontWeight="bold">
                                                Signature uploaded successfully!
                                            </Typography>
                                        </MDBox>
                                        <Box
                                            sx={{
                                                display: 'inline-block',
                                                p: 2.5,
                                                border: '3px solid #4caf50',
                                                borderRadius: 2,
                                                backgroundColor: '#f1f8f4',
                                                position: 'relative',
                                                boxShadow: '0 4px 12px rgba(76,175,80,0.2)',
                                            }}
                                        >
                                            <img
                                                src={newSignature}
                                                alt="New Signature"
                                                style={{
                                                    maxWidth: '350px',
                                                    maxHeight: '150px',
                                                    display: 'block',
                                                }}
                                            />
                                            <IconButton
                                                size="small"
                                                onClick={handleRemoveNewSignature}
                                                sx={{
                                                    position: 'absolute',
                                                    top: -12,
                                                    right: -12,
                                                    bgcolor: 'white',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                    '&:hover': {
                                                        bgcolor: '#ffebee',
                                                    }
                                                }}
                                            >
                                                <Delete fontSize="small" color="error" />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                ) : (
                                    <Box sx={{ textAlign: 'center', py: 3 }}>
                                        <CloudUpload sx={{ fontSize: 64, color: '#667eea', mb: 2 }} />
                                        <Typography variant="h5" color="text.primary" mb={1} fontWeight="bold">
                                            Upload Your Signature
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" mb={3}>
                                            Please provide your signature to re-approve this clearance
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" display="block" mb={3}>
                                            Accepted formats: JPG, PNG, GIF • Maximum size: 2MB
                                        </Typography>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            startIcon={<CloudUpload />}
                                            sx={{
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                py: 1.5,
                                                px: 5,
                                                borderRadius: 2,
                                                textTransform: 'none',
                                                fontSize: '1.1rem',
                                                fontWeight: 600,
                                                boxShadow: '0 4px 12px rgba(102,126,234,0.4)',
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
                                                    boxShadow: '0 6px 16px rgba(102,126,234,0.5)',
                                                    transform: 'translateY(-2px)',
                                                },
                                                transition: 'all 0.3s ease',
                                            }}
                                        >
                                            Choose Signature File
                                            <input
                                                type="file"
                                                hidden
                                                accept="image/*"
                                                onChange={handleNewSignatureUpload}
                                            />
                                        </Button>
                                    </Box>
                                )}
                            </Card>
                        </>
                    )}
                </DialogContent>

                <DialogActions
                    sx={{
                        p: 3,
                        backgroundColor: 'white',
                        borderTop: '1px solid #e0e0e0',
                        gap: 2,
                    }}
                >
                    <MDButton
                        variant="outlined"
                        color="secondary"
                        onClick={handleSignatureDialogCancel}
                        sx={{
                            borderWidth: 2,
                            borderColor: '#9e9e9e',
                            color: '#616161',
                            px: 3,
                            py: 1,
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            '&:hover': {
                                borderWidth: 2,
                                borderColor: '#757575',
                                backgroundColor: '#f5f5f5',
                            }
                        }}
                    >
                        Cancel
                    </MDButton>
                    <MDButton
                        variant="gradient"
                        color="info"
                        onClick={handleSignatureDialogConfirm}
                        disabled={
                            loading ||
                            (existingEmpId === empId && signatureChoice === 'new' && !newSignature) ||
                            (existingEmpId !== empId && !newSignature)
                        }
                        sx={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            px: 4,
                            py: 1,
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            boxShadow: '0 4px 12px rgba(102,126,234,0.4)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
                                boxShadow: '0 6px 16px rgba(102,126,234,0.5)',
                            },
                            '&:disabled': {
                                background: '#e0e0e0',
                                color: '#9e9e9e',
                            }
                        }}
                    >
                        {loading ? (
                            <>
                                <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                                Processing...
                            </>
                        ) : (
                            <>
                                <CheckCircleIcon sx={{ mr: 1, fontSize: 20 }} />
                                Confirm & Re-approve
                            </>
                        )}
                    </MDButton>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};

export default ITClearanceUpdateForm;